__turbopack_context__.v({
  "close": "index-module-scss-module__Cm7PcW__close",
  "show": "index-module-scss-module__Cm7PcW__show",
  "video": "index-module-scss-module__Cm7PcW__video",
});
